import { useTranslation } from "react-i18next";

import { Color } from "utils/theme";
import { PLACEHOLDER } from "utils/constants";
import { roundNumber } from "utils/formatters";
import { useStore } from "hooks/use-store";
import { Block } from "components/ui/block";

export const BasicBlocks = () => {
  const { t } = useTranslation();

  const sog = useStore((state) => state.sog);
  const rog = useStore((state) => state.rog);
  const impact = useStore((state) => state.impact);
  const peakImpact = useStore((state) => state.peakImpact);
  const redImpacts = useStore((state) => state.redImpacts);
  const config = useStore((state) => state.config);

  const sogLabel = t("dashboard.sog");
  const impactLabel = t("dashboard.impact");
  const peakImpactLabel = t("dashboard.peak_impact");
  const redImpactsLabel = t("dashboard.red_impacts");
  const knots = t("units.knots");
  const gForce = t("units.g_force");
  const impactsOverLimit = t("dashboard.impacts_over_limit");

  // A safety speed of 0 means no safety limit is set, so never warn
  const speedAlert = sog !== null && rog !== null && rog > 0 && sog >= rog;
  const impactAlert =
    impact !== null &&
    (config?.max_impact ? impact >= config?.max_impact : impact >= 3);

  const getTextColor = (alert: boolean) => {
    if (alert) return Color.Rose[600];
    return Color.White;
  };

  return (
    <div className="h-full w-full flex flex-wrap">
      <Block
        header={sogLabel}
        footer={knots}
        value={sog !== null ? Math.round(sog) : PLACEHOLDER}
        valueColor={getTextColor(speedAlert)}
        className="w-full sm:w-[calc(50%-0.5rem)] lg:w-[calc(33.3%-0.5rem)] m-1"
      />
      <Block
        header={impactLabel}
        footer={gForce}
        value={impact ?? PLACEHOLDER}
        valueColor={impactAlert ? "text-rose-600" : ""}
        className="w-full sm:w-[calc(50%-0.5rem)] lg:w-[calc(33.3%-0.5rem)] m-1"
      />
      <Block
        header={peakImpactLabel}
        footer={gForce}
        value={peakImpact.toString()}
        className="w-full sm:w-[calc(50%-0.5rem)] lg:w-[calc(33.3%-0.5rem)] m-1"
      />
      <Block
        header={redImpactsLabel}
        footer={impactsOverLimit}
        value={roundNumber(redImpacts.toString()).toString()}
        className="w-full sm:w-[calc(50%-0.5rem)] lg:hidden m-1"
      />
    </div>
  );
};
